import {
  ApplicationConfig,
  importProvidersFrom,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { pendingRequestsInterceptor$ } from 'ng-http-loader';
import { provideToastr } from 'ngx-toastr';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import {
  popperVariation,
  provideTippyConfig,
  provideTippyLoader,
  tooltipVariation,
} from '@ngneat/helipopper/config';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { provideMarkdown } from 'ngx-markdown';
import { provideNgxStripe } from 'ngx-stripe';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideTippyLoader(() => import('tippy.js')),
    provideTippyConfig({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
    }),
    importProvidersFrom(NgxSmartModalModule.forRoot()),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withViewTransitions()
    ),
    provideHttpClient(
      withInterceptors([pendingRequestsInterceptor$, authInterceptor, errorInterceptor])
    ),
    provideMarkdown(),
    provideToastr({
      preventDuplicates: true,
      progressBar: false,
      positionClass: 'toast-bottom-right',
      timeOut: 5000,
      toastClass: 'toast-custom ngx-toastr',
      messageClass: 'text-sm',
      iconClasses: {
        success: 'bx bx-sm inline bx-check-circle toast-custom-success',
        error: 'bx bx-sm inline bx-error-circle toast-custom-error',
        warning: 'bx bx-sm inline bx-x-circle toast-custom-warning',
        info: 'bx bx-sm inline bx-info-circle toast-custom-info',
      },
    }),
    provideNgxStripe(),
    importProvidersFrom(NgxDaterangepickerMd.forRoot()),
    provideMarkdown(),
    provideAnimations()
  ],
};
